<template>
  <div class="main">
    <webheader></webheader>
    <el-scrollbar style="height:100%; ">
      <div class="content">
        <!-- <div class="understand-img "           >
        <img src="../assets/img/about/01.png"
             alt=""
             class="cover">
      </div> -->
        <div class="understand-msg">
          <div style="height:207px"></div>
          <div class="first-title  ">了解神漫
          </div>
          <div class="flex-top"
               style="padding-top:40px; ">
            <div class="text-gradient">
              <div class="en-title">
                ABOUT US
              </div>
            </div>
          </div>
          <div class=" flex-top"
               style="padding-top:40px;">
            <div class="understand-info"> 神漫文化坐落于美丽的星城长沙，立足于制作国产高品质动漫影视产品， 拥有动态漫画、3d动画、虚拟偶像等全系列CG开发能力。 2020年公司确立以自主版权为核心，玄幻题材为路线的动画番剧定位。</div>
          </div>
          <div class="flex-top"
               style="padding-top:280px;">
            <div class="next-info">
              <div class="next-img flex-top"
                   @click="scrollView('.ip')">
                <img src="../assets/img/next.png" />
                <span class="desc-text active pl-16">进入IP储备</span>
              </div>
            </div>
          </div>
        </div>
        <div class="ip">
          <div style="height:130px"></div>
          <div class="first-title  ">IP储备
          </div>
          <div class="flex-top"
               style="padding-top:40px; ">
            <div class="text-gradient">
              <div class="en-title">
                IP reserves
              </div>
            </div>
          </div>
          <div class=" flex-top"
               style="padding-top:40px;">
            <div class="ip-items"
                 v-for="(item,index) in ipList"
                 :key="index">
              <div class="ip-img">

                <img v-show="item.src!=''"
                     src="../assets/img/about/7.png"
                     height="309px" />

              </div>
              <div class="ip-name"
                   v-show="item.name!=''">{{item.name}}</div>
              <div class="ip-writer"
                   v-show="item.writer!=''"> <img src="../assets/img/about/8.png"
                     style="padding-right:6px" />{{item.writer}}</div>
            </div>
          </div>
          <div class="flex-top"
               style="padding-top:90px;">
            <div class="next-info"
                 @click="scrollView('.elegant')">
              <div class="next-img flex-top">
                <img src="../assets/img/next.png" />
                <span class="desc-text active pl-16">进入神漫风采</span>
              </div>
            </div>
          </div>
        </div>
        <div class="elegant-msg animate elegant">
          <div style="height:160px"></div>
          <div class="flex-top elegant-info flex-column">
            <div class="larger-title">神漫风采</div>
            <div class="larger-en-title"
                 style="padding-top:60px;">elegant demeanour</div>
            <div class="next-info"
                 @click="scrollView('.technical')"
                 style="padding-top:180px;">
              <div class="next-img flex-top">
                <img src="../assets/img/next.png" />
                <span class="desc-text active pl-16"
                      @click="ver=5;wheelTimes=0">进入技术与艺术</span>
              </div>
            </div>
          </div>
        </div>
        <div class=" flex-left  animate  technical">
          <div class="elegant-left flex-right flex-column">
            <div class="active-title ">技术与艺术——</div>
            <div class="flex-right active-desc">
              <div class="active-desc-title "
                   style="width: 465px;">
                神漫文化作为中国引擎动画的开创者，始终走在动画技术前端。 以自主版权为核心，专注于东方幻想的深度研究与开发。
              </div>
            </div>
            <div class="next-img   flex-right"
                 @click="scrollView('.share-msg')"
                 style="width:100%;padding-top:100px;padding-right:8px">
              <img src="../assets/img/next.png" />
              <span class="desc-text active pl-16">进入分享与合作</span>
            </div>
          </div>
          <div class="elegant-right">
            <img src="../assets/img/about/03.png" />
          </div>
          <div style="padding-right:15%"></div>
        </div>
        <div class="flex-left share-msg  animate">
          <div class="elegant-left flex-right flex-column">
            <div class="flex-top flex-column"
                 style="height:100%">
              <div class="active-title ">分享与合作——</div>
              <div class="flex-right active-desc">
                <div class="active-desc-title "
                     style="width: 648px; text-align:left">
                  神漫文化始终贯彻以为观众创造优质的动画内容为目标，以传播先进的动画理念为己任。 聚焦内容本身，保持开放、分享的态度。
                </div>
              </div>
              <div class="next-img   flex-right"   @click="scrollView('.enterainment-msg')"
                   style="width:100%;padding-top:100px;padding-right:8px">
                <img src="../assets/img/next.png" />
                <span class="desc-text active pl-16">进入神漫理念</span>
              </div>
              <div style="padding-right:60%"></div>
            </div>
          </div>
        </div>
        <div class="  animate enterainment-msg"
             style="height:100%">
          <div class="enterainment"
               style="height:calc( 100% - 145px);">
            <div style="height:100px;"></div>
            <div class="flex-top flex-column">
              <div class="first-title">神漫理念</div>
              <div class="flex-top"
                   style="padding-top:40px; ">
                <div class="text-gradient">
                  <div class="en-title">
                    SHENMan Enterainment
                  </div>
                </div>
              </div>
              <div class="enterainment-desc-text"
                   style="">神漫文化在自研项目中遵循“专注、集中、高效”的理念， 产品题材聚焦定位于玄幻冒险方向。</div>
              <div class="enterainment-img">
                <img src="../assets/img/about/04.png" />
              </div>
              <div class="next-img   flex-top" @click="scrollView('.understand-msg')"
                 style="width:100%;padding-top:40px;">
              <img src="../assets/img/next.png" />
              <span class="desc-text active pl-16"
                    >返回</span>
            </div>
            </div>
          </div>
          <tabfooter></tabfooter>
        </div>
      </div>
    </el-scrollbar>
  </div>
</template>
<script>
import webheader from '@/components/webheader'
import webfooter from '@/components/webfooter'
import tabfooter from '@/components/tabfooter'
export default {
  components: { tabfooter, webfooter, webheader },
  name: 'about',
  data () {
    return {

      ipList: [
        { name: '地灵曲', src: '../assets/img/about/7.png', writer: '常磊' },
        { name: '', src: '', writer: '' },
        { name: '', src: '', writer: '' },
        { name: '', src: '', writer: '' },
        { name: '', src: '', writer: '' }
      ]
    }
  },
  activated () {

  },
  methods: {
    scrollView (domStr) {
      document.querySelector(domStr).scrollIntoView()
    }
  }
}
</script>
<style scoped>
.content {
  overflow: auto;
}
.enterainment-desc-text {
  width: 432px;
  padding-top: 40px;
  height: 76px;
  font-size: 16px;
  font-family: Source Han Sans CN;
  font-weight: 400;
  line-height: 60px;
  color: rgba(222, 222, 222, 1);
  opacity: 1;
}
.enterainment-img {
  padding-top: 40px;
}
.active-desc {
  padding-top: 70px;
  width: 100%;
  text-align: right;
}
.active-title {
  width: 100%;
  height: 50px;
  font-size: 50px;
  font-weight: 500;
  line-height: 50px;
  color: rgba(0, 255, 238, 1);
  text-align: right;
  opacity: 1;
}
.active-desc-title {
  height: 66px;
  font-size: 16px;
  font-family: Source Han Sans CN;
  font-weight: 400;
  line-height: 50px;
  color: rgba(222, 222, 222, 1);
  opacity: 1;
}
.elegant-right {
  width: 40%;
}

.elegant-left {
  width: 40%;
  height: 100%;
  padding: 155px;
}
.elegant-right {
  width: 40%;
  height: 100%;
}
.elegant-info {
  width: 100%;
  height: 100%;
}
.ip-name {
  padding-top: 40px;
  height: 24px;
  font-size: 24px;
  font-family: Source Han Sans CN;
  font-weight: 400;
  color: rgba(222, 222, 222, 1);
  opacity: 1;
}
.ip-writer {
  padding-top: 16px;
  height: 18px;
  font-size: 18px;
  font-family: Source Han Sans CN;
  font-weight: 400;
  color: rgba(222, 222, 222, 1);
  opacity: 1;
}
.ip-img {
  width: 309px;
  height: 309px;
  background: url("../assets/img/about/06.png");
}
.ip-items {
  margin: 24px;
  width: 309px;
  height: 400px;
  text-align: center;
}
.show {
  animation: 1s fadeInUp;
}
.hide {
  animation: 1s backOutUp;
  display: none;
}
.next-info {
  cursor: pointer;
  width: 172px;
  height: 68px;
}
.next-img {
  height: 68px;
  line-height: 68px;
  cursor: pointer;
}

.next-text {
  width: 48px;
  padding-left: 16px;
  height: 16px;
  font-size: 16px;
  font-family: Source Han Sans CN;
  font-weight: 400;
  line-height: 27px;
  color: rgba(222, 222, 222, 1);
  padding-bottom: 16px;
  opacity: 1;
}
.understand-info {
  width: 532px;
  height: 136px;
  font-size: 16px;
  font-family: Source Han Sans CN;
  font-weight: 400;
  line-height: 60px;
  color: rgba(222, 222, 222, 1);
  opacity: 1;
}

.understand-msg {
  width: 100%;
  height: 100%;
  background-image: url("../assets/img/about/01.png");
  background-repeat: no-repeat;
}
.elegant-msg {
  width: 100%;
  height: 100%;
  background-image: url("../assets/img/about/02.png");
  background-repeat: no-repeat;
}
.share-msg {
  width: 100%;
  height: 100%;
  background-image: url("../assets/img/about/9.png");
  background-repeat: no-repeat;
}
</style>



// WEBPACK FOOTER //
// src/view/about.vue